<template>
	<div>
		<h4 class="text-center">RECONCILE REPORTING SYSTEM</h4>

		<div class="row">

			<div class="col-auto mb-2 text-left">
				<form class="form-inline">
				  <div class="form-group">
				    <label for="dateRange" class="sr-only">Report Type</label>
				    <input type="text" disabled class="form-control-plaintext py-0" id="dateRange" style="width: 109px;" value="Report Type">
				  </div>
					<select class="custom-select py-0 pl-2 pr-0" style="height: 33px; width: 80px; background-color: transparent; border-color:  rgb(43, 53, 83); font-size: 13px;" v-model="reportType">
					  <option value="daily" style="background-color: #1a1e34;">DAILY</option>
					  <option value="weekly" style="background-color: #1a1e34;">WEEKLY</option>
					  <option value="monthly" style="background-color: #1a1e34;">MONTHLY</option>
					  <option value="yearly" style="background-color: #1a1e34;">YEARLY</option>
					</select>
				</form>
			</div>

			<div class="col-auto mb-2">
				<form class="form-inline">
				  <div class="form-group">
				    <label for="dateRange" class="sr-only">Report Period</label>
				    <input type="text" disabled class="form-control-plaintext py-0" id="dateRange" style="width: 120px;" value="Report Period">
				  </div>

				  <template v-if="reportType == 'daily'">
						<div class="form-group mr-2">
							<label for="filterDateStart" class="sr-only">Date Start</label>
							<input type="date" class="form-control py-0" id="filterDateStart" style="width: 171px; height: 33px;">
						</div>
						<div class="form-group">
							<label for="filterDateEnd" class="sr-only">Date End</label>
							<input type="date" class="form-control py-0" id="filterDateEnd" style="width: 171px; height: 33px;">
						</div>
					</template>

					<template v-else-if="reportType == 'weekly'">
					</template>

					<template v-else-if="reportType == 'monthly'">
						<select class="custom-select py-0 pl-2 pr-0" style="height: 33px; width: 100px; background-color: transparent; border-color:	rgb(43, 53, 83); font-size: 13px;" v-model="reportMonth">
							<option value="january" style="background-color: #1a1e34;">JANUARY</option>
							<option value="february" style="background-color: #1a1e34;">FEBRUARY</option>
							<option value="march" style="background-color: #1a1e34;">MARCH</option>
							<option value="april" style="background-color: #1a1e34;">APRIL</option>
							<option value="may" style="background-color: #1a1e34;">MAY</option>
							<option value="june" style="background-color: #1a1e34;">JUNE</option>
							<option value="july" style="background-color: #1a1e34;">JULY</option>
							<option value="august" style="background-color: #1a1e34;">AUGUST</option>
							<option value="september" style="background-color: #1a1e34;">SEPTEMBER</option>
							<option value="october" style="background-color: #1a1e34;">OCTOBER</option>
							<option value="november" style="background-color: #1a1e34;">NOVEMBER</option>
							<option value="december" style="background-color: #1a1e34;">DECEMBER</option>
						</select>
					</template>

					<template v-else>
						<select class="custom-select py-0 pl-2 pr-0" style="height: 33px; width: 55px; background-color: transparent; border-color:	rgb(43, 53, 83); font-size: 13px;" v-model="reportYear">
							<option v-for="n in 20" :key="n" :value="n+2000" style="background-color: #1a1e34;">{{n + 2000}}</option>
						</select>
					</template>

				</form>
			</div>

			<div class="col-auto mb-2">
				<button type="submit" class="btn btn-info m-0 px-2 py-1" style="height: 33px;">Export <i class="fas fa-download ml-2"></i></button>
			</div>

		</div>

		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-header">
						<h4 class="text-center"></h4>
						<div class="row">
							<div class="col-12 col-md-6">
								<dl class="row mb-0">
									<dt class="col-6">TRADING CONTRACT</dt>
									<dd class="col-6">
										<p>: ALL </p>
									</dd>

									<dt class="col-6">USER ACCESS</dt>
									<dd class="col-6">
										<p>: JFX - EP123456</p>
									</dd>

									<dt class="col-6">SELECT OR FILTER</dt>
									<dd class="col-6">
										<p>: CLIENT </p>
									</dd>
								</dl>
							</div>

							<div class="col-12 col-md-6">
								<dl class="row mb-0">
									<dt class="col-6">TOTAL TURN OVER</dt>
									<dd class="col-6">
										<dl class="row mb-0">
											<dt class="col-12"></dt>
											<dd class="col-9"><p>USD</p></dd>

											<dt class="col-12"></dt>
											<dd class="col-9"><p>IDR</p></dd>

											<dt class="col-12"></dt>
											<dd class="col-9"><p>TOZ</p></dd>

											<dt class="col-12"></dt>
											<dd class="col-9"><p>GRAM</p></dd>
										</dl>
									</dd>
								</dl>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<table class="table table-striped">
					<thead class="text-center" style="background-color: #0f0f17">
						<tr>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">NO.</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">ACCOUNT NAME</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">HIN</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">BUY</th>
							<th colspan="3" style="border-right: 2px solid #1e1e2e; border-bottom: 2px solid #1e1e2e;">SELL</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL TRADE <br> VOLUME</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> TOZ</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">TOTAL <br> GRAM</th>
							<th rowspan="2" style="border-right: 2px solid #1e1e2e;">RATE <br> RATIO</th>
						</tr>
						<tr>
							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>

							<th style="border-right: 2px solid #1e1e2e;">$</th>
							<th style="border-right: 2px solid #1e1e2e;">TOZ</th>
							<th style="border-right: 2px solid #1e1e2e;">GRAM</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="clientsStatus == 'idle'">
							<tr v-for="client in clients[clientsPageIndex]" class="c-row-table cursor-pointer" v-bind:key="client.id" @click="showDetailClient()">
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
								<td>-</td>
							</tr>
							<tr v-if="clients.length < 1">
								<td colspan="13" class="text-center">No data available in table</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="text-center" colspan="14">
									<Loader
										size_prop="10em"
									></Loader>
								</td>
							</tr>
						</template>
					</tbody>
					<tfoot>

					</tfoot>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	import Loader from '@/components/Loader.vue'

	export default {
		name: 'CentralCounterParty',

		components: {
			Loader
		},

		data() {
			return {
				clientsStatus: 'loading',
				clients: [],

				reportType: 'daily',
				reportMonth: 'january',
				reportYear: '2019',
			}
		},

		computed: {

		}
	}
</script>